import { render, staticRenderFns } from "./jishuzhichi.vue?vue&type=template&id=f49c7b52&scoped=true&"
import script from "./jishuzhichi.vue?vue&type=script&lang=js&"
export * from "./jishuzhichi.vue?vue&type=script&lang=js&"
import style0 from "./jishuzhichi.vue?vue&type=style&index=0&id=f49c7b52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49c7b52",
  null
  
)

export default component.exports